import React, { Component } from 'react';

class BGWrapper extends Component {
  render() {
    return(
    <div style={{ backgroundImage: `url(${this.props.background})`, width: this.props.width, height: this.props.height, position: "absolute", backgroundSize: "cover" }}>
    </div>
    )
  }
}

export default BGWrapper;


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/BGWrapper.jsx